import { twMerge } from 'tailwind-merge';
import { LiliLinkSize, LiliLinkType } from './LiliLink.types';

/** Padding of the "smart" link types, which are size-driven (XS/S/M/L) rather than type-driven. */
const getSmartPadding = (size: LiliLinkSize) => {
  switch (size) {
    case LiliLinkSize.XS:
      return 'py-[4px] px-[8px]';
    case LiliLinkSize.LARGE:
      return 'py-[12px] px-[16px]';
    default:
      return 'py-[8px] px-[12px]';
  }
};

export const getLinkStyle = (
  type: LiliLinkType = LiliLinkType.DEFAULT,
  size: LiliLinkSize = LiliLinkSize.MEDIUM
) => {
  switch (type) {
    case LiliLinkType.DEFAULT:
      return 'underline text-text-brand-primary hover:text-text-brand-primary-hover';
    case LiliLinkType.QUIET:
      return 'text-text-brand-primary hover:text-text-brand-primary-hover';
    case LiliLinkType.SMART:
      return `text-text-brand-primary hover:text-text-brand-primary-hover ${getSmartPadding(size)} hover:bg-surface-brand-action-00 rounded-[4px]`;
    case LiliLinkType.SMART_SECONDARY:
      return `text-text-main-primary hover:text-text-main-primary ${getSmartPadding(size)} hover:bg-surface-primary-bw-25 rounded-[4px]`;
    case LiliLinkType.SECONDARY:
      return 'hover:underline text-text-main-secondary hover:text-text-main-primary';
    case LiliLinkType.SECONDARY_QUITE:
      return 'text-text-main-secondary hover:text-text-main-primary';
  }
};

export const getLinkSize = (size: LiliLinkSize = LiliLinkSize.MEDIUM) => {
  switch (size) {
    case LiliLinkSize.XS:
    case LiliLinkSize.SMALL:
      return `text-[14px] leading-[16px]`;
    case LiliLinkSize.MEDIUM:
    case LiliLinkSize.LARGE:
      return `text-[16px] leading-[24px]`;
  }
};

export const getLinkClassName = (
  type: LiliLinkType,
  size: LiliLinkSize,
  fontClass: string,
  className?: string,
  disabled?: boolean
) =>
  twMerge(
    'flex gap-[2px] items-center [&_svg]:text-inherit',
    fontClass,
    disabled ? 'text-text-main-disabled pointer-events-none' : getLinkStyle(type, size),
    getLinkSize(size),
    disabled ? '' : 'cursor-pointer',
    className
  );
